/** Cliente do Navegador Premium — backend no geocoder (/geo/v1/navigation). */

export interface NavSession {
  id: number;
  status: string;
  origin: string;
  route_name: string | null;
  started_at: string | null;
  finished_at: string | null;
  total_distance_meters: number | null;
  total_distance_nm: number | null;
  total_time_seconds: number | null;
  average_speed: number | null;
  max_speed: number | null;
  points_count: number | null;
  destination_latitude?: number | null;
  destination_longitude?: number | null;
}

export interface NavCoord {
  latitude: number;
  longitude: number;
  speed?: number | null;
  recorded_at?: string | null;
}

export interface NavRouteDetail extends NavSession {
  coords: NavCoord[];
}

const BASE = '/geo/v1/navigation';

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const r = await fetch(url, { credentials: 'include', ...init });
  if (!r.ok) throw new Error(`navigation ${r.status}`);
  if (r.status === 204) return undefined as T;
  return r.json() as Promise<T>;
}

const json = (body: unknown): RequestInit => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

export const navigationApi = {
  start: (body: {
    route_name?: string | null;
    origin?: 'app' | 'tracker';
    destination_latitude?: number | null;
    destination_longitude?: number | null;
    destination_point_id?: number | null;
    start_latitude?: number | null;
    start_longitude?: number | null;
  }) => req<NavSession>(`${BASE}/start`, json(body)),

  update: (session_id: number, points: NavCoord[]) =>
    req<void>(`${BASE}/update`, json({ session_id, points })),

  finish: (session_id: number) => req<NavSession>(`${BASE}/finish`, json({ session_id })),

  routes: () => req<NavSession[]>(`${BASE}/routes`),
  detail: (id: number) => req<NavRouteDetail>(`${BASE}/routes/${id}`),
  remove: (id: number) => req<void>(`${BASE}/routes/${id}`, { method: 'DELETE' }),
  share: (id: number) => req<{ shared: boolean }>(`${BASE}/routes/${id}/share`, { method: 'POST' }),
};
